import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faTrash } from '@fortawesome/free-solid-svg-icons'
import './MultiFileItem.scss'

const MultiFileItem = ({ file, deleteFile }) => {
    return (
        <>
            <li
                className="multifile-item"
                key={file.name}>
                <FontAwesomeIcon icon={faFileAlt} />
                <p>{file.name}</p>
                <div className="actions">
                        <FontAwesomeIcon icon={faTrash}
                            onClick={() => deleteFile(file.name)} />
                </div>
            </li>
        </>
    )
}

export default MultiFileItem